var popups = {

	allow: true,
	fadeClick: true,
	offset: 50,
	limit: 730,
	limitGallery: 930,
	backTo: false,
	type: null,
	focusTrapInstance: null,

	preInit: function () {
		// generate fade
		var f = '<div id="popupFade" class="no-print" />';
		var l = '<div id="popupLoader" class="no-print" />';
		// append popups
		$('body').append(f + l);
		// resize - only close when width actually changes (prevents Samsung Galaxy virtual
		// keyboard open/close from incorrectly closing mobile popups)
		var previousWidth = $(window).width();
		$(window).on('resize', function () {
			var currentWidth = $(window).width();
			if (currentWidth !== previousWidth && currentWidth < popups.limit && popups.type !== 'small' && popups.type !== 'medium') {
				popups.close();
			}
			previousWidth = currentWidth;
		});
		// escape
		$(document).on('keyup', function (e) {
			if (e.key == "Escape") {
				popups.close();
			}
		});
		// continue
		popups.init();
	},

	init: function () {

		// launch
		$('a.js-popup-launch').each(function () {
			var link = $(this);
			// click
			link.off('click').on('click', function () {
				popups.launch(link.attr('href'), link.attr('data-template') || null, link.attr('data-mobile-popup') === 'true');
				return false;
			});
		});

		// grab
		$('a.js-popup-grab').each(function () {
			var link = $(this);
			// click
			link.off('click').on('click', function () {
				popups.grab(link.attr('href'), link.attr('data-title'));
				return false;
			});
		});

		// confirm
		$('a.js-popup-confirm').each(function () {
			var link = $(this);
			// click
			link.off('click').on('click', function () {
				var title = link.attr('data-title');
				var text = link.attr('data-text');
				var yesValue = link.attr('data-yes-value');
				var noValue = link.attr('data-no-value');
				popups.confirm(title, text, link.attr('href'), false, yesValue, noValue);
				return false;
			});
		});

		// youtube embed
		$('a[href*="youtube.com/embed/"]').each(function () {
			var link = $(this);
			// click
			link.off('click').on('click', function () {
				popups.video(link.attr('href') + '?rel=0&autoplay=1');
				return false;
			});
		});

		// youtube video
		$('a[href*="youtube.com/watch?v="]').each(function () {
			var link = $(this);
			// click
			link.off('click').on('click', function () {
				popups.video('//www.youtube.com/embed/' + link.attr('href').split('?v=')[1] + '?rel=0&autoplay=1');
				return false;
			});
		});

		// image
		$('a.js-popup-image').each(function () {
			var link = $(this);
			// click
			link.off('click').on('click', function () {
				popups.image(link.attr('data-title') || '', link.attr('href'));
				return false;
			});
		});

		// gallery
		$('a.js-popup-gallery').each(function () {
			var link = $(this);
			// click
			link.off('click').on('click', function () {
				var data = [];
				link.closest('.js-gallery').find('.js-slide').each(function () {
					data.push({
						Src: $(this).attr('data-zoom')
					})
				});
				popups.gallery(data, link.attr('data-index'));
				return false;
			});
		});

		// vin search
		$('a.js-popup-vin-search').each(function () {
			var link = $(this);
			var settingsData = $.parseJSON($('#jsModelSettings').html()).Data;

			// click
			link.off('click').on('click', function () {
				popups.vinSearch(settingsData);
				return false;
			});
		});

		// close
		$('.m-popup .js-close, #popupFade, #popupConfirmNo').each(function () {
			var link = $(this);
			// click
			link.off('click').on('click', function () {
				popups.close();
				return false;
			});
		});

		// forms
		popups.forms();

	},

	loader: function (hide, keepFade) {
		var p = $('#popupLoader');
		var f = $('#popupFade');

		if (hide) {
			p.hide();
			if (!keepFade) {
				f.hide();
			}
			popups.allow = true;
			popups.fadeClick = false;
			return;
		}
		if (popups.allow) {
			p.show();
			f.show();
			popups.allow = false;
			popups.fadeClick = false;
		}
	},

	launch: function (url, template, allowMobilePopup) {

		// allowed check
		if (!popups.allow || ($(window).width() < popups.limit && !allowMobilePopup) || popups.backTo) {
			location.href = url;
			return false;
		}

		// check if current url
		var comp = url.split('?')[0];
		var path = location.pathname;

		// remove comp slash
		if (comp.substr(-1) == '/') {
			comp = comp.substr(0, comp.length - 1);
		}

		// remove path slash
		if (path.substr(-1) == '/') {
			path = path.substr(0, path.length - 1);
		}

		// redirect
		if (comp == path) {
			return false;
		}

		// set type
		popups.type = 'launch';

		// show loader
		popups.loader();

		// get template
		if (typeof template === 'undefined' || template === null) {
			template = '#popupLaunchTemplate';
		}
		template = $(template).html();
		if (typeof template === 'undefined') {
			location.href = url;
			return;
		}
		// parse template
		template = Hogan.compile(template);

		// hide open popups
		var visible = $('.m-popup:visible');
		if (visible.length > 0) {
			// set backto
			popups.backTo = true;
			// set attr
			visible.attr('data-hidden', 'true').hide();
		}

		// get page content
		$.ajax({
			url: url,
			cache: false,
			success: function (response) {
				var responseMarkup = $(response);
				var wrapper = responseMarkup.filter('#popupContentWrapper').add(responseMarkup.find('#popupContentWrapper')).first();
				var content = wrapper.html();
				if (typeof content === 'undefined') {
					location.href = url;
					return;
				}
				// render template
				var rendered = template.render({
					content: content,
					url: url
				});
				// add template to body
				$('body').append(rendered);
				// get popup
				var p = $('.m-popup[data-href="' + url + '"]');
				// set top
				p.css('top', popups.getTop());
				// init
				popups.init();
				// show
				p.add('#popupFade:hidden').show();
				// scroll to popup - iOS reports scrollTop as 0 when scrolled, so the popup can
				// be positioned off-screen; scrolling ensures it is always visible
				window.scrollTo(0, p.offset().top - popups.offset);
				// hide loader
				popups.loader(true, true);
				popups.allow = true;
				popups.fadeClick = true;
				// analytics
				if (site && site.analytics) {
					site.analytics.page(url, 'Popup');
				}
				popups.trapFocus();

			},
			error: function (e) {
				// hide loader
				popups.loader(true);
				popups.allow = true;
				popups.fadeClick = true;
				// show notice
				popups.confirm('Error', 'Sorry, the URL "' + url + '" could not be shown (' + e.statusText.toLowerCase() + ').', '', true);
			}
		});
	},

	grab: function (id, title) {
		var content = $(id);

		// allowed check
		if (!popups.allow || popups.backTo || !content.length) {
			return false;
		}

		// set type
		popups.type = 'grab';

		// show loader
		popups.loader();

		// get template
		var template = $('#popupGrabTemplate').html();
		if (typeof template === 'undefined') return false;

		// parse template
		template = Hogan.compile(template);

		// hide open popups
		var visible = $('.m-popup:visible');
		if (visible.length > 0) {
			// set backto
			popups.backTo = true;
			// set attr
			visible.attr('data-hidden', 'true').hide();
		}

		// get markup
		var rendered = template.render({
			title: title || '',
			content: content.html()
		});

		// add template to body
		$('body').append(rendered);

		// get popup
		var p = $('#popupGrab');

		// set top
		p.css('top', popups.getTop());

		// init
		popups.init();

		// show
		p.add('#popupFade:hidden').show();

		// hide loader
		popups.loader(true, true);
		popups.allow = true;
		popups.fadeClick = true;

		// trap focus
		popups.trapFocus();
	},

	video: function (src) {
		// allowed check
		if (!popups.allow || $(window).width() < popups.limit || popups.backTo) {
			window.open(src);
			return;
		}
		popups.allow = false;

		// get template
		var template = Hogan.compile($('#popupVideoTemplate').html());

		// hide open popups
		var visible = $('.m-popup:visible');
		if (visible.length > 0) {
			// set backto
			popups.backTo = true;
			// set attr
			visible.attr('data-hidden', 'true').hide();
		}

		// set type
		popups.type = 'video';

		// render template
		var rendered = template.render({
			src: src
		});
		// add template to body
		$('body').append(rendered);

		// get popup
		var p = $('#popupVideo');
		// set top
		p.css('top', popups.getTop());
		// ajax trigger
		$(document).trigger('ajaxComplete');
		// show
		p.add('#popupFade').show();
		// allow popups
		popups.allow = true;

		// trap focus
		popups.trapFocus();
	},

	confirm: function (title, text, url, notice, yesValue, noValue) {
		// allowed check
		if (!popups.allow || popups.backTo) {
			popups.close();
		}
		popups.allow = false;

		// get template
		var template = Hogan.compile($('#popupConfirmTemplate').html());

		// render template
		var rendered = template.render({
			title: title || 'Confirm',
			text: text || 'Are you sure? This cannot be undone.',
			url: url,
			isNotice: !notice,
			confirm: yesValue || 'Confirm',
			cancel: noValue || 'Cancel'
		});
		// add template to body
		$('body').append(rendered);

		// set type
		popups.type = 'small';

		// get popup
		var p = $('#popupConfirm');
		// set top
		p.css('top', popups.getTop());
		// init
		popups.init();
		// show
		p.add('#popupFade').show();
		// allow popups
		popups.allow = true;

		// trap focus
		popups.trapFocus();
	},

	image: function(title, image) {
		// allowed check
		if (!popups.allow || popups.backTo) {
			popups.close();
		}
		popups.allow = false;

		// get template
		var template = Hogan.compile($('#popupImageTemplate').html());

		// render template
		var rendered = template.render({
			Title: title,
			Image: image
		});
		// add template to body
		$('body').append(rendered);

		// set type
		popups.type = 'image';

		// get popup
		var p = $('#popupImage');
		// set top
		p.css('top', popups.getTop());
		// init
		popups.init();
		// show
		p.add('#popupFade').show();
		// scroll to popup - iOS reports scrollTop as 0 when scrolled, so the popup can
		// be positioned off-screen; scrolling ensures it is always visible
		window.scrollTo(0, p.offset().top - popups.offset);
		// allow popups
		popups.allow = true;

		// trap focus
		popups.trapFocus();
	},

	gallery: function (data, index) {
		// allowed check
		if (!popups.allow || popups.backTo) {
			popups.close();
		}
		popups.allow = false;

		// get template
		var template = Hogan.compile($('#popupGalleryTemplate').html());

		// render template
		var rendered = template.render({
			Data: data
		});
		// add template to body
		$('body').append(rendered);

		// set type
		popups.type = 'small';

		// get popup
		var p = $('#popupGallery');

		// set top
		p.css('top', popups.getTop());

		// init
		popups.init();

		// show
		p.add('#popupFade').show();

		// set slider
		if (p.find('.js-gallery-item').length > 1) {
			p.find('.js-gallery').bxSlider({
				mode: 'fade',
				auto: false,
				startSlide: index || 0,
				speed: 250,
				infiniteLoop: false,
				hideControlOnEnd: true
			});
		}

		// allow popups
		popups.allow = true;

		// trap focus
		popups.trapFocus();
	},

	vinSearch: function (settingsData) {
		// allowed check
		if (!popups.allow || popups.backTo) {
			popups.close();
		}
		popups.allow = false;

		// get template
		var template = Hogan.compile($('#popupVinSearchTemplate').html());

		var hasVideoLink = settingsData.HelpVideoLink === "" ? false : true;
		var hasHelpText = settingsData.HelpText === "" ? false : true;
		var hasHelpHeading = settingsData.HelpHeading === "" ? false : true;

		// render template
		var rendered = template.render({
			OverlayHeading: settingsData.OverlayHeading || "Find your Bailey Model",
			OverlayText: settingsData.OverlayText || "to find the right parts quickly",
			HelpHeading: settingsData.HelpHeading ,
			HelpText: settingsData.HelpText ,
			HelpVideoLink: settingsData.HelpVideoLink,
			HasVideoLink: hasVideoLink,
			HasHelpText: hasHelpText,
			HasHelpHeading: hasHelpHeading,
			VinSearchHelpLink: settingsData.VinSearchHelpLink,
		});

		// add template to body
		$('body').append(rendered);

		// set type
		popups.type = 'small';

		// get popup
		var p = $('#popupVinSearch');
		// set top
		p.css('top', popups.getTop());
		// ajax trigger
		$(document).trigger('ajaxComplete');
		// show
		p.add('#popupFade').show();
		// allow popups
		popups.allow = true;
		// trap focus
		popups.trapFocus();
	},

	productCompatibility: function (data) {
		// allowed check
		if (!popups.allow || popups.backTo) {
			popups.close();
		}
		popups.allow = false;

		// get template
		var template = Hogan.compile($('#popupProductCompatibilityTemplate').html());

		// render template
		var rendered = template.render({
			Data: data
		});
		// add template to body
		$('body').append(rendered);

		// set type
		popups.type = 'medium';

		// get popup
		var p = $('#popupProductCompatibility');
		// set top
		p.css('top', popups.getTop());
		// ajax trigger
		$(document).trigger('ajaxComplete');
		// show
		p.add('#popupFade').show();
		// allow popups
		popups.allow = true;

		// trap focus
		popups.trapFocus();
	},

	forms: function() {
		$('.m-popup form:not(.js-form-done):not(.js-popup-search-form)').each(function () {
			var form = $(this);
			var button = form.find(':submit');

			// submit
			form.on('submit', function () {
				// reset validation
				form.removeData('validator');
				form.removeData('unobtrusiveValidation');
				// validate form
				$.validator.unobtrusive.parse(form);
				// check
				if (form.valid()) {
					// disable button
					button.addClass('disabled').prop('disabled', true);
					if (form.hasClass('js-vin-form')) {
						return;
					}
					// submit
					$.ajax({
						type: 'POST',
						url: form.attr('action'),
						data: form.serialize(),
						cache: false,
						success: function (response) {
							// remove error
							form.prev('.js-ajax-error').remove();
							// check
							if (response.Valid) {
								// close popup and navigate
								popups.close();
								location.href = response.Url;
							}
							else {
								// add error
								form.before('<p class="form-error js-ajax-error">' + response.Message + '</p>');
							}
						},
						error: function () {
							// remove error
							form.prev('.js-ajax-error').remove();
							// add error
							form.before('<p class="form-error js-ajax-error">Sorry, there was an unexpected server error.</p>');
						},
						complete: function () {
							// enable button
							button.removeClass('disabled').prop('disabled', false);
						}
					});
				}
				return false;
			});

			// done
			form.addClass('js-form-done');
		});

		// search forms inside popups and reload popup content in-place
		$('.m-popup form.js-popup-search-form:not(.js-form-done)').each(function () {
			var form = $(this);
			var button = form.find(':submit');

			form.on('submit', function () {
				button.addClass('disabled').prop('disabled', true);

				$.ajax({
					type: 'POST',
					url: form.attr('action'),
					data: form.serialize(),
					cache: false,
					success: function (response) {
						form.prev('.js-ajax-error').remove();
						var responseMarkup = $(response);
						var wrapper = responseMarkup.filter('#popupContentWrapper').add(responseMarkup.find('#popupContentWrapper')).first();
						var newContent = wrapper.html();
						if (typeof newContent !== 'undefined') {
							var contentArea = form.closest('.m-popup__content');
							contentArea.html(newContent);
							popups.forms();
						}
					},
					error: function () {
						form.prev('.js-ajax-error').remove();
						form.before('<p class="form-error js-ajax-error">Sorry, there was an unexpected server error.</p>');
					},
					complete: function () {
						button.removeClass('disabled').prop('disabled', false);
					}
				});

				return false;
			});

			form.addClass('js-form-done');
		});
	},

	close: function (keepFade) {
		var p = $('.m-popup:not([data-visible]):visible');
		if (!popups.allow) {
			return;
		}
		popups.allow = false;
		// hide loader
		popups.loader(true, true);
		// hide popups
		if (popups.backTo) {
			popups.backTo = false;
			$('.m-popup[data-hidden]').removeAttr('data-hidden').show();
		}
		else if (!keepFade) {
			// hide fade
			$('#popupFade').hide();
		}
		// remove popup
		p.remove();
		// clear type
		popups.type = null;
		// allow popups
		popups.allow = true;
		// allow fade click
		popups.fadeClick = true;
		// trap focus
		popups.trapFocus();
	},

	getTop: function () {
		// window.pageYOffset is more reliable than scrollTop on iOS Safari
		var top = window.pageYOffset !== undefined ? window.pageYOffset : $(window).scrollTop();
		return parseInt(top + popups.offset, 10);
	},

	trapFocus: function () {

		if (popups.focusTrapInstance) {

			popups.focusTrapInstance.removeListener();
			popups.focusTrapInstance = null;

		}

		var activePopup = $('.m-popup:visible');
		if (!activePopup.length) return;

		popups.focusTrapInstance = new TrapFocus(activePopup[0]);

		activePopup.find('a,button').first().focus();

  }

};

$(document).ajaxComplete(function () {
	popups.init();
});
